import { useEffect, useState } from 'react'
import useGenericEndpoint from './useGenericEndpoint'
import { useStore } from '../../store'

const useGenericStoreEndpoint = (
  url,
  setActionType,
  storeKey,
  options = {}
) => {
  const [localData, setLocalData] = useState(null)
  const { data, isLoading, hasLoadError } = useGenericEndpoint(url, options)

  const { dispatch, state } = useStore()

  useEffect(() => {
    if (isLoading || hasLoadError) return

    const value = data[storeKey]
    setLocalData(value)
    dispatch({ type: setActionType, [storeKey]: value })
  }, [data, isLoading, hasLoadError])

  const commitToStore = () => {
    dispatch({ type: setActionType, [storeKey]: localData })
  }

  return {
    isLoading: isLoading || !state[storeKey],
    hasLoadError,
    [storeKey]: state[storeKey],
    localData,
    setLocalData,
    commitToStore,
  }
}

export default useGenericStoreEndpoint
